import React from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';
import { MillerColumns } from './MillerColumns';

export const ComponentNavigator = ({
    columns,
    selectedPath,
    onSelect,
    loadingColumnIndex,
    onError,
    loading = false,
}) => (
    <div className="component-manager-navigator">
        <Dimmer active={loading} inverted>
            <Loader>Loading...</Loader>
        </Dimmer>
        <MillerColumns
            columns={columns}
            selectedPath={selectedPath}
            onSelect={onSelect}
            loadingColumnIndex={loadingColumnIndex}
            expansionKey="has_dependents"
            onError={onError}
        />
    </div>
);
